// We should update this module to its latest version to use a dynamic import if we want to support SSR builds. This will prevent the error coming from using a null import.
const AddSearchClient = typeof window !== `undefined` ? require("addsearch-js-client") : null;

const PUBLIC_API_TOKEN = "32c2d1fdc8fe47dfd59c772e4a8a9263"; // We might want to move this to an environment variable in the future.

const addSearchClientBase = AddSearchClient ? new AddSearchClient(PUBLIC_API_TOKEN) : null;

/**
 * SearchOptionsData
 * @typedef {Object} SearchOptionsData
 * @property {string} numberOfResults - We use by default 1 to just get/save the record of the first match in the search in AddSearch search records.
 * @property ... and more, check https://www.npmjs.com/package/addsearch-js-client or https://www.addsearch.com/docs/api/search-results for more info.
 */

/**
 * Sends a search statistics event to AddSearch and perform the search.
 *
 * @param {string} searchText - The text that was searched.
 * @param {SearchOptionsData} options - Optional parameters for the "search" event, check https://www.npmjs.com/package/addsearch-js-client or https://www.addsearch.com/docs/api/search-results for more info.
 */
const statsSearchEvent = (searchText = "", options = {}) => {
  if (addSearchClientBase) {
    // We define numberOfResults as 1 to just get/save the record of the first match in the search in AddSearch search records.
    addSearchClientBase.sendStatsEvent("search", searchText, { numberOfResults: 1, ...options });
  }
};

/**
 * ClickOptionsData
 * @typedef {Object} ClickOptionsData
 * @property {string} documentId - The ID of the clicked document/suggestion element form AddSearch array of results.
 * @property {number} position - The position of the clicked document in the search results.
 * @property ... and more, check https://www.npmjs.com/package/addsearch-js-client or https://www.addsearch.com/docs/api/search-results for more info.
 */

/**
 * Sends a click statistics event to AddSearch.
 *
 * @param {string} clickedText - The text that was clicked.
 * @param {ClickOptionsData} options - Parameters related to the clicked document.
 */
const statsSearchClick = (clickedText = "", options = {}) => {
  if (addSearchClientBase) {
    addSearchClientBase.sendStatsEvent("click", clickedText, options);
  }
};

/**
 * Performs a search using the AddSearch Client, this is for searching without saving the search records.
 *
 * @param {string} query - The search query string.
 * @param {function} callback - The callback function to handle the search results.
 */
const performSearch = (query = "", callback = () => {}) => {
  if (addSearchClientBase) {
    addSearchClientBase.search(query, callback);
  }
};

export const addSearchClient = addSearchClientBase
  ? {
      ...addSearchClientBase,
      statsSearchEvent,
      statsSearchClick,
      performSearch
    }
  : null;
